import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  computed,
} from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgSharedModule, PipesModule } from '@principle-theorem/ng-shared';
import { first } from 'lodash';
import { IMohFormDisplay } from '@principle-theorem/principle-core/interfaces';
import { MatButtonModule } from '@angular/material/button';
import { LetDirective } from '@ngrx/component';
import { MohFormViewerService } from './moh-form-viewer.service';

@Component({
  selector: 'pr-moh-form-viewer',
  imports: [
    MatButtonToggleModule,
    MatToolbarModule,
    PipesModule,
    MatButtonModule,
    LetDirective,
    CommonModule,
    NgSharedModule,
  ],
  templateUrl: './moh-form-viewer.component.html',
  styleUrl: './moh-form-viewer.component.scss',
  host: { class: 'flex-1 flex flex-col' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MohFormViewerService],
})
export class MohFormViewerComponent {
  service = inject(MohFormViewerService);
  forms = input.required<IMohFormDisplay[]>();
  immutable = input(true);
  showHeader = computed(() => !this.immutable() || this.forms().length > 1);

  constructor() {
    effect(() => this.service.activeForm.set(first(this.forms())));
  }
}
